import assign from 'lodash/assign';
import ngTranslate from 'angular-translate';

import { ModelModule } from 'services/data/model/model.module';
import { MyAccountServiceModule } from 'services/data/myAccount.service';

import template from './verifyEmailReminder.html';
import './verifyEmailReminder.scss';

export const VerifyEmailReminderModule = angular
    .module('app.components.verifyEmailReminder', [
        ngTranslate,
        'ngMaterial',
        ModelModule,
        MyAccountServiceModule
    ]).component('verifyEmailReminder', {
        template,
        controller: class VerifyEmailReminderController {
            constructor(
                $scope,
                $translate,
                $q,
                $mdToast,
                $mdDialog,
                myAccountService,
                modelService
            ) {
                assign(this, {
                    loading: false,
                    user: {},

                    $scope,
                    $translate,
                    $q,
                    $mdToast,
                    $mdDialog,
                    myAccountService,
                    modelService
                });
            }

            $onInit() {
                this.getUser();
            }

            getUser() {
                this.myAccountService.getUser().then((response) => {
                    this.user = this.modelService.makeModel(response, 'userModel');
                });
            }

            resend() {
                this.myAccountService.resendVerification(this.user);
                this.presentEmailSentModal();
            }

            dismiss() {
                this.$mdToast.hide();
            }

            presentEmailSentModal() {
                this.$q.all([
                    this.$translate('NOTIFICATION.RESENT'),
                    this.$translate('ONBOARDING.VERIFICATION_EMAIL_TOAST')
                ]).then((translations) => {
                    this.$mdDialog.show(
                        this.$mdDialog.alert()
                            .title(translations[0])
                            .textContent(translations[1])
                            .ok('Ok')
                            .clickOutsideToClose(true)
                    );
                });
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/verifyEmailReminder/verifyEmailReminder.component.js